import type { LevelConfig } from '../index';

export const level8: LevelConfig = {
  id: 'level_8',
  stage: '2',
  mapId: 'map_08',
  timeLimitSec: 140,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'collect_coins', target: 40 },
  enemies: [
    { type: 'BASIC_SCAMMER', position: { x: 350, y: 300 }, patrolPath: [{ x: 350, y: 300 }, { x: 350, y: 500 }] },
    { type: 'BASIC_SCAMMER', position: { x: 600, y: 400 }, patrolPath: [{ x: 600, y: 400 }, { x: 600, y: 600 }] },
    { type: 'BASIC_SCAMMER', position: { x: 450, y: 700 }, patrolPath: [{ x: 450, y: 700 }, { x: 450, y: 850 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 750, y: 300 }, patrolPath: [{ x: 750, y: 300 }, { x: 750, y: 500 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 300, y: 550 }, patrolPath: [{ x: 300, y: 550 }, { x: 500, y: 550 }] },
    { type: 'SUPPORT_SCAMMER', position: { x: 650, y: 700 }, patrolPath: [{ x: 650, y: 700 }, { x: 800, y: 700 }, { x: 800, y: 850 }] },
  ],
  loot: [
    ...Array.from({ length: 45 }, (_, i) => ({
      type: 'COIN' as const,
      position: { x: 160 + (i % 7) * 110, y: 200 + Math.floor(i / 7) * 110 },
      value: 10,
    })),
  ],
  startingWeapon: 'RIFLE',
  startingAmmo: 5,
  unlocks: [],
};
